import type { DataTableHeader } from '@/types/vuetify';
import i18n from '@/plugins/i18n';

export function createBetSettlementPageHeaders(): DataTableHeader[] {
    const t = i18n.global.t;

    return [
        { title: t('betSettlement.date'), value: 'created_at', key: 'created_at', align: 'start', sortable: true, nowrap: true },
        { title: t('betSettlement.type'), value: 'type_id', key: 'type_id', align: 'start', sortable: true, nowrap: true },
        { title: t('betSettlement.bookmaker'), value: 'site_id', key: 'site_id', align: 'start', sortable: true, nowrap: true },
        { title: t('betSettlement.account'), value: 'account_login', key: 'account_login', align: 'start', sortable: true, nowrap: true },
        { title: t('betSettlement.betId'), value: 'internal_id', key: 'internal_id', align: 'start', sortable: true, nowrap: true },
        { title: t('betSettlement.bookBetId'), value: 'ref', key: 'ref', align: 'start', sortable: true, nowrap: true },
        { title: t('betSettlement.betDate'), value: 'bet_created_at', key: 'bet_created_at', align: 'center', sortable: true, nowrap: true },
        { title: t('betSettlement.bookmakerOdds'), value: 'odds', key: 'odds', align: 'end', sortable: true, nowrap: true },
        { title: t('betSettlement.stake'), value: 'stake', key: 'stake', align: 'end', sortable: true, nowrap: true },
        { title: t('betSettlement.balance'), value: 'balance', key: 'balance', align: 'end', sortable: true, nowrap: true },
        { title: t('betSettlement.validBalance'), value: 'valid_balance', key: 'valid_balance', align: 'end', sortable: true, nowrap: true },
        { title: '', value: 'result', key: 'result', align: 'end', sortable: true, nowrap: true },
        { title: '', value: 'actions', key: 'actions', align: 'end', sortable: false, nowrap: true, width: 48, cellProps: { class: 'pl-0 pr-1' } },
    ];
}
